import { PureQueryOptions } from '@apollo/client';

import { MyTaskCountersBadgeDocument } from 'core/graphql';
import { userStateVar } from 'core/state/userState';
import { UserRole } from 'types';

import { MANAGEMENT_ROLES, visibleFor } from '../Palette/paletteRoles';
import {
  COUNTER_AGGREGATE_QUERIES,
  TCounterRefetch,
} from '../Communications/commsCounterQueries';

/**
 * Кому сервер отдаёт `myTaskCounters` — зеркало `TASK_ACCESS_ROLES` бэкенда
 * (= `MANAGEMENT_ROLES`). Остальным запрос не шлём: отказ сервера лёг бы
 * ошибкой в консоль на каждом экране.
 */
export const MY_TASK_COUNTERS_ROLES: UserRole[] = MANAGEMENT_ROLES;

/** Положен ли роли бейдж просроченных задач; без аргумента — текущий вход. */
export const canReadTaskCounters = (roles?: readonly string[]): boolean =>
  visibleFor(
    [...(roles ?? userStateVar().me?.roles ?? [])] as UserRole[],
    MY_TASK_COUNTERS_ROLES,
  );

/**
 * Перечитать бейдж меню: документом (не по имени — Apollo 3.3.6 по имени
 * будит и skip-нутые экземпляры, перепроверка F47) и только если роли он
 * положен. Роли читаются В МОМЕНТ вызова, поэтому функция.
 */
export const myTaskCountersRefetch = (): PureQueryOptions[] =>
  canReadTaskCounters() ? [{ query: MyTaskCountersBadgeDocument }] : [];

/**
 * ТЗ 0129 — что перечитывают мутации задач: просрочка в разбивке групп
 * (`GroupsOverviewList`, по имени) и бейдж меню `myTaskCounters`. Счётчики
 * коммуникатора задача больше не трогает.
 */
export const taskCounterRefetch = (): TCounterRefetch[] => [
  ...COUNTER_AGGREGATE_QUERIES,
  ...myTaskCountersRefetch(),
];
